import React from 'react';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';
import RecordDetails from '../../molecules/RecordDetails/RecordDetails';
import { inventionColumns, inventionFields, useInventionOptions } from '../InventionsPage/InventionsPage';
import { cityLabel, namesOf, useSelectOptions } from '../../../helpers/selectOptions';
import './ScholarsPage.scss';

const ScholarsPage = () => {
  const inventionOptions = useInventionOptions();
  const { cities } = inventionOptions;
  const scholarFields = useSelectOptions('fields?per_page=500', field => field.name);
  // eslint-disable-next-line react/prop-types
  const expanded = ({ data }) => (
    <div className="scholar-details">
      <RecordDetails
        items={[
          { label: 'Origin', value: data.origin ? cityLabel(data.origin) : undefined },
          { label: 'Cities', value: namesOf(data.cities) },
          { label: 'Fields', value: namesOf(data.fields) },
          { label: 'Key work', value: data.key_work },
          { label: 'Contribution', value: data.contribution !== data.key_work ? data.contribution : undefined },
        ]}
      />
      <div className="scholar-inventions">
        <ReactiveTable
          title={`${data.name} Inventions`}
          columns={inventionColumns}
          endpoint="types/inventions"
          exportableKeys={['code', 'name', 'kind', 'score', 'xr_object']}
          modalTitle="Invention"
          fields={inventionFields(inventionOptions, [data.id])}
          extraParameters={[{ scholar_id: data.id }]}
        />
      </div>
    </div>
  );
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
      width: '90px',
    },
    {
      name: 'Scholar',
      selector: row => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Born',
      selector: row => row.born,
      width: '100px',
    },
    {
      name: 'Died',
      selector: row => row.died,
      width: '100px',
    },
    {
      name: 'Fields',
      selector: row => namesOf(row.fields),
      wrap: true,
    },
    {
      name: 'Inventions',
      selector: row => row.inventions_count,
      sortable: true,
      width: '110px',
    },
  ];
  const fields = [
    'code',
    'name',
    'born',
    'died',
    {
      key: 'origin_city_id',
      type: 'select',
      options: cities,
    },
    {
      key: 'fields_ids',
      type: 'multiselect',
      options: scholarFields,
      valueFrom: scholar => scholar.fields.map(field => field.id),
      createEndpoint: 'fields',
    },
    { key: 'key_work', type: 'textarea' },
    { key: 'contribution', type: 'textarea' },
    {
      key: 'cities_ids',
      type: 'multiselect',
      options: cities,
      valueFrom: scholar => scholar.cities.map(city => city.id),
    },
  ];
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Scholars</h2>
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          endpoint="types/scholars"
          expandedComponent={expanded}
          exportableKeys={['code', 'name', 'born', 'died', 'origin_city_id', 'key_work']}
          modalTitle="Scholar"
          fields={fields}
        />
      </div>
    </>
  );
};

export default ScholarsPage;
